import { render, staticRenderFns } from "./statAppointFeeDates.vue?vue&type=template&id=68a3765b"
import script from "./statAppointFeeDates.vue?vue&type=script&lang=js"
export * from "./statAppointFeeDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports